import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import CopyToClipboard from 'react-copy-to-clipboard';
import Lottie from 'lottie-react';
import { NumberCircleTwo, NumberCircleOne, Info } from '@phosphor-icons/react';
import InfoCard from '../../../../components/info-card/infoCard';
import mixpanel from 'mixpanel-browser';
import SearchBar from '../icons/SearchBar.json';
import PaytmInsider from '../icons/PaytmInsider.json';
import BookMyShow from '../icons/BookMyShow.json';
import ZomatoLive from '../icons/ZomatoLive.json';
import { District } from '../icons';
import { useSelector } from 'react-redux';


const LOTTIE_MAP = {
  bms: BookMyShow,
  insider: PaytmInsider,
  zomato: District,
};

const Step2 = ({ selectedPlatform }) => {
  const [copiedTicket, setCopiedTicket] = useState(false);
  const [copiedMail, setCopiedMail] = useState(false);
  const mailtoCopy = 'tickets@takemytickets.co.in';

  const { userData } = useSelector((state)=>state.app);
  const { eventData } = useSelector((state) => state.sellTickets);''
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCopyTicket = () => {
    setCopiedTicket(true);
    mixpanel.track("Event_Name_Copied", {
        "event_id": eventData?._id || null,
        "event_name": eventData?.name || "N/A",
        "user_id": userData?._id || "Anonymous",
        "page_url": window.location.href,
    });
    setTimeout(() => setCopiedTicket(false), 3000);
  };

  const handleCopyMail = () => {
    setCopiedMail(true);
      mixpanel.track("Mail_Copied", {
        "event_id": eventData?._id || null,
        "event_name": eventData?.name || "N/A",
        "user_id": userData?._id || "Anonymous",
        "page_url": window.location.href,
    });
    setTimeout(() => setCopiedMail(false), 3000);
  };

  return (
    <div className="flex flex-col gap-6 pt-9">
      <Helmet>
        <title>Verify tickets</title>
        <meta
          name="Sell Tickets Easily in India | Reach Your Audience on Take My Tickets"
          content="Start selling your event tickets hassle-free on Take My Tickets, India's trusted ticket resale platform. Add seller contact details effortlessly."
        />
        <meta charset="UTF-8" />
      </Helmet>
      <div className="flex flex-col gap-4">
        <div className="md:heading-36 heading-24">
          Forward your ticket email to verify
        </div>
        <InfoCard
          icon={<Info size={24} color='#FF2459' weight="fill" />}
          content="Forward the ticket email from your registered Take My Tickets email"
          className="info bg-light"
        />
        <div className="md:text-16 text-grey-70">
          To ensure ticket validity and fair pricing, we need your consent to
          verify ticket details. We never use or share your tickets with anyone.
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-1">
          <div className="flex gap-3 items-start">
            <NumberCircleOne size={36}
              weight="fill" />
            <div className="flex flex-col gap-3 items-start justify-center w-full">
              <div className="flex flex-col gap-1">
                <div className="flex heading-16">Find your ticket in mail</div>
                <div className="md:text-16 text-grey-70 hidden md:block">
                  Open gmail and paste this keyword in gmail inbox search to
                  quickly find your tickets
                </div>
              </div>
              <div className="py-4 px-3 flex justify-between border border-dashed border-grey-30 rounded-xl w-full text-12">
                <div>
                  {eventData.name ? eventData.name : 'Loading...'}
                  {' '}
                  {selectedPlatform?.label}
                </div>
                <CopyToClipboard
                  text={`${eventData?.name} ${selectedPlatform?.label}`}
                  onCopy={handleCopyTicket}
                >
                  <div>
                    {!copiedTicket ? (
                      <p className="text-primary text-14 cursor-pointer">
                        Copy
                      </p>
                    ) : (
                      <p className="text-primary-green text-14 cursor-pointer flex">
                        <img
                          className="mr-1"
                          src="/images/icons/green_tick.svg"
                          alt=""
                        />{' '}
                        Copied!
                      </p>
                    )}
                  </div>
                </CopyToClipboard>
              </div>
              <Lottie
                animationData={SearchBar}
                loop={true}
                className="object-cover items-center self-stretch rounded-lg bg-grey-10 h-[64px] w-full"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-1">
          <div className="flex gap-3 items-start">
            <NumberCircleTwo size={36}
              weight="fill" />
            <div className="flex flex-col gap-3 items-start justify-center w-full">
              <div className="flex flex-col gap-1">
                <div className="flex heading-16">Forward the mail to us</div>
                <div className="md:text-16 text-grey-70 hidden md:block">
                  Come back to this page once you have forwarded your ticket.
                </div>
              </div>
              <div className="py-4 px-3 flex justify-between border border-dashed border-grey-30 rounded-xl w-full text-12">
                <div>{mailtoCopy}</div>
                <CopyToClipboard text={mailtoCopy}
                  onCopy={handleCopyMail}>
                  <div>
                    {!copiedMail ? (
                      <p className="text-primary text-14 cursor-pointer">
                        Copy
                      </p>
                    ) : (
                      <p className="text-primary-green text-14 cursor-pointer flex">
                        <img
                          className="mr-1"
                          src="/images/icons/green_tick.svg"
                          alt=""
                        />{' '}
                        Copied!
                      </p>
                    )}
                  </div>
                </CopyToClipboard>
              </div>
              <Lottie
                animationData={LOTTIE_MAP[selectedPlatform.id]}
                loop={true}
                className="object-cover items-center self-stretch rounded-lg bg-grey-10 h-[64px] w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step2;
